import { atom, selector } from 'recoil';
import orderBy from 'lodash/orderBy';
import { CustomPropertyAttribute } from '../types/CustomPropertyAttribute';

export const customPropertyAttributesAtom = atom<
  CustomPropertyAttribute[] | undefined
>({
  key: 'custom-property-attributes',
  default: undefined,
});

export const activeCustomPropertyAttributesSelector = selector({
  key: 'active-custom-property-attributes',
  get: ({ get }) => {
    const attributes = get(customPropertyAttributesAtom);
    const activeAttributes = attributes?.filter(({ active }) => active);
    return activeAttributes && orderBy(activeAttributes, 'order');
  },
});
